import { useQuery } from '@tanstack/react-query';
import { apiHelper } from '../lib/api';

// Query keys
export const geoKeys = {
  all: ['geo'],
  countries: () => [...geoKeys.all, 'countries'],
  states: (countryId) => [...geoKeys.all, 'states', countryId],
  lgas: (stateId) => [...geoKeys.all, 'lgas', stateId],
};

// Fetch countries
export function useCountries() {
  return useQuery({
    queryKey: geoKeys.countries(),
    queryFn: () => apiHelper.getResource('/org/geography/?geo_type=COUNTRY'),
  });
}

// Fetch states by country
export function useStates(countryId) {
  return useQuery({
    queryKey: geoKeys.states(countryId),
    queryFn: () => apiHelper.getResource(`/org/geography/?geo_type=STATE&parent=${countryId}`),
    enabled: !!countryId,
  });
}

// Fetch LGAs by state
export function useLgas(stateId) {
  return useQuery({
    queryKey: geoKeys.lgas(stateId),
    queryFn: () => apiHelper.getResource(`/org/geography/?geo_type=LGA&parent=${stateId}`),
    enabled: !!stateId,
  });
}
